import { Box, Chip, Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { MediumCustomIcon } from "../../layer00";

export type CheckInWeekHeaderProps = {
  date: DateTime;
};

export const CheckInWeekHeader = (props: CheckInWeekHeaderProps) => {
  const weekStart = props.date.startOf("week");
  const weekEnd = weekStart.plus({
    days: 4,
  });
  const dateRange = `${weekStart.toFormat("LLL d")} - ${weekEnd.toFormat(
    "LLL d"
  )}`;

  return (
    <Stack direction="column" alignItems="center" rowGap=".75rem">
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        columnGap=".5rem"
      >
        <MediumCustomIcon icon="FLAG" />
        <Typography variant="cardBodyHeader">Weekly check in</Typography>
        <Chip
          variant="info"
          label={dateRange}
          sx={{
            paddingX: ".5rem",
          }}
        />
      </Box>
      <Typography
        variant="chatMessageBody"
        className="text-teamApp-text-inactive"
        textAlign="center"
        sx={{
          maxWidth: "30rem",
        }}
      >
        You can check in at any time. At the end of the work week we&apos;ll
        close this chat and start a new one. This is your chance to let senior
        leaders know what&apos;s going on.
      </Typography>
    </Stack>
  );
};
